import { render, staticRenderFns } from "./profileMPNKO.vue?vue&type=template&id=d61559ec"
import script from "./profileMPNKO.vue?vue&type=script&lang=js"
export * from "./profileMPNKO.vue?vue&type=script&lang=js"
import style0 from "./profileMPNKO.vue?vue&type=style&index=0&id=d61559ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports